/**
 * This function calculates the location of the icon wrapper within the given fields
 * @param {number[]} lineHeights - the line height for every line
 * @param {number[]} lines - the number of lines for each field
 * @param {number} iconHeight - the height for the icon field
 * @param {number} totalHeight - the total height
 * @returns which location the icon should go into
 */
export default function calculateIconLocationSizings(
    lineHeights: number[],
    lines: number[],
    iconHeight: number,
    totalHeight: number
): IconLocationType {
    let iconLocation = IconLocationType.Unknown;
    let usedHeight = 0;

    lines.forEach((line, index) => {
        let fieldHeight = line * lineHeights[index];
        usedHeight += fieldHeight;
        if (usedHeight >= totalHeight - iconHeight && iconLocation == IconLocationType.Unknown) {
            iconLocation = index;
        }
    });

    if (iconLocation == IconLocationType.Unknown) {
        iconLocation = IconLocationType.BelowAll;
    }

    return iconLocation;
}

export enum IconLocationType {
    Unknown = -1,
    Subject = 0,
    Location = 1,
    Organizer = 2,
    BelowAll = 3,
}
